export default "__VITE_ASSET__BNzSHJn3__"